"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.organizationVimeoUpdate = exports.organizationUpdate = exports.organizationSuccess = exports.organizationSoftDelete = exports.organizationSelect = exports.organizationReset = exports.organizationPlatformUpdate = exports.organizationListSoftDeleted = exports.organizationList = exports.organizationFetch = exports.organizationError = exports.organizationDetail = exports.organizationAdd = void 0;
var _organization = require("./organization.constant");
// @flow

// common success
var organizationSuccess = function organizationSuccess(actionType, data) {
  return {
    type: _organization.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.organizationSuccess = organizationSuccess;
var organizationError = function organizationError(actionType, error) {
  return {
    type: _organization.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.organizationError = organizationError;
var organizationFetch = function organizationFetch(data) {
  return {
    type: _organization.actionTypes.FETCH,
    payload: data
  };
};

/**
 * detail
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.organizationFetch = organizationFetch;
var organizationDetail = function organizationDetail(data) {
  return {
    type: _organization.actionTypes.DETAIL,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.organizationDetail = organizationDetail;
var organizationList = function organizationList(data) {
  return {
    type: _organization.actionTypes.LIST,
    payload: data
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete data.
 */
exports.organizationList = organizationList;
var organizationListSoftDeleted = function organizationListSoftDeleted(data) {
  return {
    type: _organization.actionTypes.LIST_SOFT_DELETED,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
exports.organizationListSoftDeleted = organizationListSoftDeleted;
var organizationSoftDelete = function organizationSoftDelete(data) {
  return {
    type: _organization.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.organizationSoftDelete = organizationSoftDelete;
var organizationAdd = function organizationAdd(data) {
  return {
    type: _organization.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.organizationAdd = organizationAdd;
var organizationUpdate = function organizationUpdate(param, data) {
  return {
    type: _organization.actionTypes.UPDATE,
    payload: {
      param: param,
      data: data
    }
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.organizationUpdate = organizationUpdate;
var organizationVimeoUpdate = function organizationVimeoUpdate(data) {
  return {
    type: _organization.actionTypes.VIMEO_UPDATE,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.organizationVimeoUpdate = organizationVimeoUpdate;
var organizationPlatformUpdate = function organizationPlatformUpdate(data) {
  return {
    type: _organization.actionTypes.PLATFORM_UPDATE,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to select one item.
 */
exports.organizationPlatformUpdate = organizationPlatformUpdate;
var organizationSelect = function organizationSelect(data) {
  return {
    type: _organization.actionTypes.SELECT,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset item.
 */
exports.organizationSelect = organizationSelect;
var organizationReset = function organizationReset() {
  return {
    type: _organization.actionTypes.RESET
  };
};
exports.organizationReset = organizationReset;